import{createContext as o}from"react";var n=o({config:null});export{n as a};
//# sourceMappingURL=chunk-5UX4CEQZ.mjs.map